import { RolesEnum } from "@wc/domain/authz";

export const TeamRoles = [RolesEnum.TEAM_ADMIN, RolesEnum.TEAM_MEMBER];
